import type { RouteRecordRaw } from 'vue-router'

const configRoutes: RouteRecordRaw[] = [
  {
    path: 'config/ai-knowledge',
    name: 'AiKnowledge',
    component: () => import('@/pages/ai-agent-studio/KnowledgePage.vue'),
    meta: { title: '知识库', parent: '配置' },
  },
  {
    path: 'config/ai-qa-records',
    name: 'AiQaRecords',
    component: () => import('@/pages/ai-agent-studio/QaRecordsPage.vue'),
    meta: { title: '问答记录', parent: '配置' },
  },
  {
    path: 'config/customer-groups',
    name: 'CustomerGroupSettings',
    component: () => import('@/pages/config/CustomerGroupSettings.vue'),
    meta: { title: '客户阶段分组', parent: '配置' },
  },
  {
    path: 'config/ai-workbench',
    name: 'AiConfigWorkbench',
    component: () => import('@/pages/ai-agent-studio/CompanyAgentsPage.vue'),
    meta: { title: 'AI 配置工作台', parent: '配置' },
  },
  {
    path: 'config/ai-workbench/detail',
    name: 'AiAgentStudio',
    component: () => import('@/pages/ai-agent-studio/AgentStudioPage.vue'),
    meta: { title: '智能体配置', parent: 'AI 配置工作台' },
  },
  {
    path: 'config/customer-service',
    name: 'CustomerServiceConfig',
    component: () => import('@/pages/config/CustomerService.vue'),
    meta: { title: '客服管理', parent: '配置', requiresPsi: true },
  },
  {
    path: 'config/project',
    name: 'ProjectConfig',
    component: () => import('@/pages/config/ProjectConfig.vue'),
    meta: { title: '项目配置', parent: '配置', requiresPsi: true },
  },
  {
    path: 'projects/operation-brief',
    name: 'ProjectOperationBrief',
    component: () => import('@/pages/orders/operation-brief.vue'),
    meta: { title: '项目运营简报', parent: '项目分析', requiresPsi: true },
  },
  {
    path: 'projects/report',
    name: 'ProjectReport',
    component: () => import('@/pages/projects/ProjectReport.vue'),
    meta: { title: '项目运营报表', parent: '项目分析', requiresPsi: true },
  },
  {
    path: 'statistics/project-report',
    name: 'OperationsProjectReport',
    component: () => import('@/pages/projects/ProjectReport.vue'),
    meta: { title: '项目运营报表', parent: '项目分析', requiresPsi: true },
  },
  {
    path: 'config/order-business-setting',
    name: 'OrderBusinessSettingConfig',
    component: () => import('@/pages/config/OrderBusinessSetting.vue'),
    meta: { title: '订单业务参数', parent: '配置', requiresPsi: true },
  },
  {
    path: 'config/order-types',
    name: 'OrderTypeSettings',
    component: () => import('@/pages/config/OrderTypeSettings.vue'),
    meta: { title: '订单类型设置', parent: '配置', requiresPsi: true },
  },
  {
    path: 'config/deal-cycle-settings',
    name: 'DealCycleSettings',
    component: () => import('@/pages/config/DealCycleSettings.vue'),
    meta: { title: '成交周期设置', parent: '配置', requiresPsi: true },
  },
  {
    path: 'config/customer-tags',
    name: 'CustomerTagSettings',
    component: () => import('@/pages/config/CustomerTagSettings.vue'),
    meta: { title: '客户标签设置', parent: '配置' },
  },
  // 进销存业务设置路由已注释，功能保留在订单业务参数配置页
  // {
  //   path: 'config/psi-business-setting',
  //   name: 'PsiBusinessSetting',
  //   component: () => import('@/pages/config/PsiBusinessSetting.vue'),
  //   meta: { title: '进销存业务设置', parent: '配置', requiresPsi: true },
  // },
]

export default configRoutes
